import { useLocation } from 'react-router';

export const usePathEndingHook = () => {
    const location = useLocation();
    const pathParts = location.pathname.split('/');

    return pathParts[pathParts.length - 1];
};
